var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemale({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41602 23.0001V20.3334H3.74935V17.6667H6.41602V14.8667C4.66046 14.5556 3.22157 13.7167 2.09935 12.3501C0.977127 10.9834 0.416016 9.40007 0.416016 7.60007C0.416016 5.57784 1.13268 3.86118 2.56602 2.45007C3.99935 1.03895 5.72713 0.333399 7.74935 0.333399C9.77157 0.333399 11.4993 1.03895 12.9327 2.45007C14.366 3.86118 15.0827 5.57784 15.0827 7.60007C15.0827 9.40007 14.5216 10.9834 13.3993 12.3501C12.2771 13.7167 10.8382 14.5556 9.08268 14.8667V17.6667H11.7493V20.3334H9.08268V23.0001H6.41602ZM7.74935 12.3334C9.03824 12.3334 10.1382 11.8778 11.0493 10.9667C11.9605 10.0556 12.416 8.95562 12.416 7.66673C12.416 6.37784 11.9605 5.27784 11.0493 4.36673C10.1382 3.45562 9.03824 3.00007 7.74935 3.00007C6.46046 3.00007 5.36046 3.45562 4.44935 4.36673C3.53824 5.27784 3.08268 6.37784 3.08268 7.66673C3.08268 8.95562 3.53824 10.0556 4.44935 10.9667C5.36046 11.8778 6.46046 12.3334 7.74935 12.3334Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/Female.8a4ec2d92ce821deeb7d1c1035002086.svg";
export { ForwardRef as ReactComponent };